import { createContext, SetStateAction, Dispatch } from 'react';
import { Nullable } from '../../utilities/common_types';

interface Token {
  token: Nullable<string>;
  setToken: Dispatch<SetStateAction<Nullable<string>>>;
  expiry: Nullable<Date>;
  setExpiry: Dispatch<SetStateAction<Nullable<Date>>>;
}

export const TokenContext = createContext<Token>({
  token: null,
  setToken: () => null,
  expiry: null,
  setExpiry: () => null,
});
